import { Icon } from '@chakra-ui/react'

export const SankeyIcon = props => (
  <Icon viewBox='0 0 14 10' {...props}>
    <svg width='14' height='10' viewBox='0 0 14 10' fill='none' xmlns='http://www.w3.org/2000/svg'>
      <path d='M6.65942 9.62395H14V8.51337H7.34058L5.6436 6.29222H14V5.18164H0V6.29222H4.11398L6.65942 9.62395Z' fill='currentColor' />
      <path d='M0 4.44231H4.79511L7.34058 1.11058H14V0H6.65942L4.11398 3.33173H0V4.44231Z' fill='currentColor' />
    </svg>
  </Icon>
)
